import { send } from "@utils/fetch";
import store from "@utils/redux/store";
import { captureMessageWithExtras } from "@utils/sentry";

const createPostRequest = (url, requestBody) => {
  return send("POST", url, requestBody);
};

const apiCreateVisit = async (requestBody) => {
  return createPostRequest(`/visit/v1/create/`, requestBody)
    .then((text) => {
      console.log(`${text}! User Id: ${requestBody.id} `);
    })
    .catch((e) => {
      const { serverContext } = store.getState();
      console.log("Visit creation failed", e);
      captureMessageWithExtras("Visit creation failed", {
        extra: {
          requestBody,
          serverContext,
        },
      });
    });
};

const apiUpdateVisit = async (requestBody) => {
  return createPostRequest(`/visit/v1/update/`, requestBody)
    .then((text) => {
      console.log(`${text}! User Id: ${requestBody.id} `);
    })
    .catch((e) => {
      const { serverContext } = store.getState();
      console.log("Visit update failed", e);
      captureMessageWithExtras("Visit update failed", {
        extra: {
          requestBody,
          serverContext,
        },
      });
    });
};

export { apiCreateVisit, apiUpdateVisit };
